'use client';

import '@ui5/webcomponents/dist/SegmentedButtonItem.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * Users can use the `SegmentedButtonItem` as part of a `SegmentedButton`.
 *
 * Clicking or tapping on a `SegmentedButtonItem` changes its state to `pressed`. The item returns to its initial state when the user clicks or taps on it again. By applying additional custom CSS-styling classes, apps can give a different style to any `SegmentedButtonItem`.
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-SegmentedButton)
 */
const SegmentedButtonItem = withWebComponent('ui5-segmented-button-item', ['accessibleName', 'accessibleNameRef', 'icon', 'tooltip', 'type'], ['pressed', 'disabled'], [], ['click']);
SegmentedButtonItem.displayName = 'SegmentedButtonItem';
export { SegmentedButtonItem };